module.exports = __webpack_public_path__ + "components/flag/static/square/my-0cca667f5cf4eb4fa1fa769b11c1670b.svg";